import React from "react";
import EditIcon from "../../assets/icons/editIcon1.svg";
const EditableImage = ({
  handleRowClick,
  recordId,
  disabled,
  size = "medium",
}) => {
  const passSize = size === "small" ? "1.75rem" : "2rem";
  return (
    <img
      src={EditIcon}
      alt=""
      style={{
        height: passSize,
        width: passSize,
        cursor: "pointer",
        borderRadius: "0.5rem",
        opacity: disabled ? 0.5 : 1,
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.cursor = "pointer";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.cursor = "default";
        e.currentTarget.title = "";
      }}
      onClick={() => !disabled && handleRowClick(recordId)}
    />
  );
};

export default EditableImage;
